import * as React from 'react';

const CODEPEN = `
<iframe height="300" style="width: 100%;" scrolling="no" title="Keep CSS Weird - Scroll Linked" src="https://codepen.io/argyleink/embed/qBQByGN?default-tab=html%2Cresult" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
  See the Pen <a href="https://codepen.io/argyleink/pen/qBQByGN">
  Keep CSS Weird - Scroll Linked</a> by Adam Argyle (<a href="https://codepen.io/argyleink">@argyleink</a>)
  on <a href="https://codepen.io">CodePen</a>.
</iframe>
`;

function KeepCssWeird() {
  const ref = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = CODEPEN;
    }
  }, []);
  return <div ref={ref} />;
}

export default KeepCssWeird;
